import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import ContactBlock from './ContactBlock';
import HomeLinkBlock from './HomeLinkBlock';
import PasswordChangeBlock from './PasswordChangeBlock';
import Welcome from './Welcome';
import Helper from './Helper';
import ContainerStyled from './styles/BamAdviceStyled';

const BamAdvice = ({ contactData, contactError }) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  return (
    <>
      <ContainerStyled>
        <Welcome />
        <HomeLinkBlock />
        <PasswordChangeBlock />
        <ContactBlock contactData={contactData} contactError={contactError} />
      </ContainerStyled>
      {!isMobileDevice && <Helper />}
    </>
  );
};

BamAdvice.propTypes = {
  contactData: PropTypes.shape({
    days: PropTypes.arrayOf(PropTypes.string),
    phoneNumber: PropTypes.string,
    start: PropTypes.string,
    finish: PropTypes.string,
    enabled: PropTypes.bool,
  }),
  contactError: PropTypes.bool.isRequired,
};

BamAdvice.defaultProps = {
  contactData: {
    days: [''],
    phoneNumber: '',
    start: '',
    finish: '',
    enabled: false,
  },
};

export default BamAdvice;
